import { useGetMainList } from "ra-core";
import { FC, createContext, useContext, useMemo } from "react";
import { RecPatch } from "~/dataProvider/tools";
import { InfoTypeResponseDto } from "~/gen/api/securefile";
import { pages, sorts } from "~/utils/paramsWithGetMainList";

export interface FileInfoTypeDataContextProps {
  infoTypes: InfoTypeResponseDto[];
}

export const FileInfoTypeDataContext = createContext<FileInfoTypeDataContextProps>({} as any)

export const FileInfoTypeDataContextProvider : FC = ({ children }) => {
  const { data: infoTypesData, ids: ids1 } = useGetMainList<InfoTypeResponseDto&RecPatch>('settings/securefile/info-types', pages(), sorts(), {}, { action: 'CUSTOM_DATA_QUERY'})
  var val = useMemo(() => ({
    infoTypes: (ids1 ?? []).map((i) => infoTypesData![i]).sort((l, r) => {
      if (l.name! > r.name!) {
        return 1
      } else {
        return 0
      }
    }),
  }), [infoTypesData, ids1])
  return (
    <FileInfoTypeDataContext.Provider value={val}>
      {children}
    </FileInfoTypeDataContext.Provider>
  )
}

export const useFileInfoTypeDataContext = () => useContext(FileInfoTypeDataContext);